// @greenlight-spec: 16-api-conventions.md
// @greenlight-spec: 17-code-organization.md
import { z } from 'zod';
import { GreenlightErrorResponseSchema } from '@greenlight/shared';
// Shared `:id` path param for every app-scoped route. Domain modules extend it
// for nested ids (e.g. `AppIdParamsSchema.extend({ runId: ... })`).
export const AppIdParamsSchema = z.object({ id: z.string().uuid() });
// Slug-keyed reads. The identifier rule is docs/16 §Identifiers; validating it
// here keeps a path segment that is not a slug from reaching a query.
export const AppSlugParamsSchema = z.object({
    slug: z
        .string()
        .min(1)
        .max(63)
        .regex(/^[a-z][a-z0-9-]*[a-z0-9]$|^[a-z]$/),
});
// Canonical Greenlight error response shape, keyed by HTTP status code per
// 16-api-conventions.md §HTTP status mapping. Every route in every contract
// module spreads this so callers can rely on a uniform error body regardless
// of which route they hit.
// Intentionally NOT `as const` — that would re-narrow the numeric keys to
// string literals after object spread, which breaks `keyof` lookups in
// `ClientInferResponseBody<route, 404>` style type tests.
export const errorResponses = {
    400: GreenlightErrorResponseSchema,
    401: GreenlightErrorResponseSchema,
    403: GreenlightErrorResponseSchema,
    404: GreenlightErrorResponseSchema,
    409: GreenlightErrorResponseSchema,
    429: GreenlightErrorResponseSchema,
    500: GreenlightErrorResponseSchema,
    502: GreenlightErrorResponseSchema,
};
//# sourceMappingURL=common.js.map